import React from "react";
import styled, { css } from "styled-components";
import { SectionContainer, SectionTitle } from "screens/Homepage/styles";
import FeatureCard from "./FeatureCard";

const FeaturesSection: React.FC = () => {
  return (
    <SectionContainer>
      <SectionTitle>
        Run on our cloud, or yours.<br></br>
        <br></br>100% open source.
      </SectionTitle>
      <InnerContainer>
        <MainFeaturesGrid>
          <FeatureCard
            title="Switch hardware in seconds"
            description="Run your code on any hardware in seconds — just change one line of Python to switch hardware."
            artboard="6"
          />
          <FeatureCard
            title="Easy Local Debugging"
            description="We make it easy to test your code before deploying it, using the exact configuration you'll run in production."
            artboard="5"
          />
        </MainFeaturesGrid>
        <SecondaryFeaturesGrid>
          <FeatureCard
            title="Multiple Workers Per Container"
            description="Scale vertically by running multiple workers on the same container."
            docsUrl="https://docs.beam.cloud/v2/scaling/concurrency"
          />
          <FeatureCard
            title="Import Remote Dockerfiles"
            description="Bootstrap containers with images from remote registries."
            docsUrl="https://docs.beam.cloud/v2/environment/custom-images#adding-custom-base-images"
          />
          <FeatureCard
            title="Deploy from Github Actions"
            description="Deploy your APIs automatically by adding Beam to your existing CI/CD pipeline."
            docsUrl="https://docs.beam.cloud/v2/topics/ci"
          />
        </SecondaryFeaturesGrid>
      </InnerContainer>
    </SectionContainer>
  );
};

export default FeaturesSection;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  max-width: 1152px;
`;

const MainFeaturesGrid = styled.div`
  ${({ theme }) => {
    return css`
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px;
      width: 100%;
      justify-items: center;

      @media (max-width: ${theme.breakpoints.lg}px) {
        grid-template-columns: 1fr;
      }
    `;
  }}
`;

const SecondaryFeaturesGrid = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: row;
      gap: 24px;
      grid-gap: 24px;
      width: 100%;
      align-items: center;

      @media (max-width: ${theme.breakpoints.lg}px) {
        flex-direction: column;
      }
    `;
  }}
`;
